
import Vue from 'vue';
import Component from 'vue-class-component';
import PhotosModule from '@/store/modules/Photos';
import { getModule } from 'vuex-module-decorators';
import UploadModule from '@/store/modules/Upload';
import store from '@/store';

const photosModule = getModule(PhotosModule, store);
const uploadModule = getModule(UploadModule, store);

@Component
export default class GlobalProgress extends Vue {
    beforeUnloadListener = (e: BeforeUnloadEvent) => {
        if (uploadModule.uploadInProgress) {
            e.preventDefault();
            e.returnValue = 'Trwa konwersja plików RAW lub wysyłanie zdjęć. Zamknięcie karty przerwie ten proces.';
        }
    };

    get progress() {
        return uploadModule.overallProgress;
    }

    get uploadInProgress() {
        return uploadModule.uploadInProgress;
    }

    get waitingForProgress() {
        return uploadModule.waitingForUploadProgress;
    }

    created() {
        window.addEventListener('beforeunload', this.beforeUnloadListener);
    }

    destroyed() {
        window.removeEventListener('beforeunload', this.beforeUnloadListener);
    }
}
